export var DisplayMode;
(function (DisplayMode) {
    DisplayMode["REDIRECT"] = "REDIRECT";
    DisplayMode["CAROUSEL"] = "CAROUSEL";
    DisplayMode["TILED"] = "TILED";
    DisplayMode["SERIES"] = "SERIES";
    DisplayMode["CAROUSEL_SLIDES"] = "CAROUSEL_SLIDES";
})(DisplayMode || (DisplayMode = {}));
//# sourceMappingURL=Collection.js.map